/* eslint-disable import/extensions */
import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import Metrics from 'services/metrics';
import { GetRegion } from 'constants.js';
import {
  setProfileLastTouch,
  setProfileLastTouchFavorited,
} from '../../../utils/Socialization';
import { LOAD_USER_LOGIN } from '../constants';
import {
  pendingUserLogInEmail,
  errorUserLogInEmail,
  actionUserIsLoggedIn,
} from '../actions';
import { userLogin } from '../service';
import { INVALID_PASSWORD } from 'api/interceptors/shared/errorCodes';
import { DEFAULTS_FORGOTTEN_PASSWORD_METRIC } from 'containers/Login/constants';

export function* sendUserLogInEmail({ payload }) {
  yield put(pendingUserLogInEmail());
  try {
    const {
      email,
      password,
      login,
      claroLiteConfig,
      callback,
      isForgotenPassword = false,
    } = payload;
    const params = {
      body: {
        username: email,
        password,
      },
      params: {},
      claroAdsConfig: claroLiteConfig,
    };

    const request = yield call(userLogin, params);
    const { response, errors, status } = request;
    const isLogged = _.parseInt(status);
    const acceptTerms = _.parseInt(_.get(response, ['accepted_terms']));
    if (response?.lasttouch) {
      const { profile, favorited } = response.lasttouch;

      if (profile) setProfileLastTouch(profile);
      if (favorited) setProfileLastTouchFavorited(favorited);
    }

    if (isLogged === 0 || (isLogged === 1 && acceptTerms === 0)) {
      if (acceptTerms === 0) localStorage.setItem('handleTermsFromLogin', 1);
      Metrics.newEvent({
        event: 'Login',
        eventCategory: 'landing',
        eventAction: 'inicia sesion',
        eventLabel: 'exitoso - correo',
      });

      const metricsParams = {
        event: 'login',
        method: 'correo electronico',
        parent_id: response?.parent_id,
        user_id: response?.user_id,
        user_type: 'registrado',
        country: GetRegion(),
      };

      const { event_name, ...forgottenMetrics } = DEFAULTS_FORGOTTEN_PASSWORD_METRIC
      const forgottenMetricsParams = {
        ...forgottenMetrics,
        client_id: window?.ga?.getAll()?.[0].get('clientId'),
        client_id_custom: window?.ga?.getAll()?.[0].get('clientId'),
        name: 'login',
        user_id: response?.user_id,
        sign_up_method: "correo electronico",
        user_type: "registrado",
        user_id_custom: response?.user_id,
        timestamp_micros: Date.now() * 1000,
        page_path: "homeuser",
        page_title: 'modal cambiar contraseña',
        engagement_time_msec: 0,
        method: "correo electronico",
      }
      
      Metrics.newEvent(isForgotenPassword ?  forgottenMetricsParams : metricsParams);

      yield put(actionUserIsLoggedIn({ login, response }));

      if (typeof callback === 'function') {
        callback(response);
      }
    } else {
      Metrics.newEvent({
        event: 'Error',
        eventCategory: 'Errores',
        eventAction: 'Error',
        eventLabel: `Iniciar_Sesión-Usuario_y_contraseña-(WEB)_API_${
          errors?.code
        }-${errors?.type === 'internal' ? 'int' : 'ext'}`,
        Pais: GetRegion(),
        Device: 'web',
      });
      if (!errors) {
        const error = { code: INVALID_PASSWORD };
        yield put(errorUserLogInEmail(error));
        callback(error);
      } else {
        console.log(errors);
        Array.isArray(errors)
          ? yield put(errorUserLogInEmail(errors[0]))
          : yield put(errorUserLogInEmail(errors));
      }
    }
  } catch (error) {
    const { errors } = error?.response?.data || {};

    Metrics.newEvent({
      event: 'Error',
      eventCategory: 'Errores',
      eventAction: 'Error',
      eventLabel: `Iniciar_Sesión-Usuario_y_contraseña-(WEB)-API_${
        errors?.code
      }-${errors?.type === 'internal' ? 'Int' : 'Ext'}`,
      Pais: GetRegion(),
      Device: 'web',
    });

    yield put(errorUserLogInEmail(errors));
  }
}

export default function* UserLogInEmailSaga() {
  yield takeLatest(LOAD_USER_LOGIN.ACTION, sendUserLogInEmail);
}
